import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

export type DecisionFormValues = {
  file_number: string;
  name: string;
  authority: string;
  decision_date: string;
  subject: string;
};

type Props = {
  show: boolean;
  title: string;
  initialValues?: Partial<DecisionFormValues>;
  saving?: boolean;
  error?: string | null;
  onHide: () => void;
  onSubmit: (values: DecisionFormValues) => void;
};

const emptyValues: DecisionFormValues = {
  file_number: '',
  name: '',
  authority: '',
  decision_date: '',
  subject: '',
};

export default function DecisionFormModal({
  show,
  title,
  initialValues,
  saving = false,
  error,
  onHide,
  onSubmit,
}: Props) {
  const [values, setValues] = useState<DecisionFormValues>(emptyValues);

  useEffect(() => {
    if (show) {
      setValues({
        ...emptyValues,
        ...initialValues,
      });
    }
  }, [show, initialValues]);

  const updateField = (
    field: keyof DecisionFormValues,
    value: string
  ) => {
    setValues((current) => ({
      ...current,
      [field]: value,
    }));
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg"
      backdrop
      className="stacked-modal"
      backdropClassName="stacked-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Behörde</Form.Label>
            <Form.Control
              value={values.authority}
              onChange={(e) => updateField('authority', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ausstellungsdatum</Form.Label>
            <Form.Control
              type="date"
              value={values.decision_date}
              onChange={(e) => updateField('decision_date', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Aktenzeichen</Form.Label>
            <Form.Control
              value={values.file_number}
              onChange={(e) => updateField('file_number', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Thematik</Form.Label>
            <Form.Control
              value={values.name}
              onChange={(e) => updateField('name', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Inhalt</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={values.subject}
              onChange={(e) => updateField('subject', e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Abbrechen
        </Button>
        <Button
          variant="primary"
          onClick={() => onSubmit(values)}
          disabled={saving}
        >
          {saving ? 'Wird gespeichert...' : 'Speichern'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}